/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./cell-container.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./cell-container.component";
var styles_CellContainerComponent = [i0.styles];
var RenderType_CellContainerComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CellContainerComponent, data: {} });
export { RenderType_CellContainerComponent as RenderType_CellContainerComponent };
export function View_CellContainerComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_CellContainerComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-cell-container", [], null, null, null, View_CellContainerComponent_0, RenderType_CellContainerComponent)), i1.ɵdid(1, 114688, null, 0, i2.CellContainerComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CellContainerComponentNgFactory = i1.ɵccf("cc-cell-container", i2.CellContainerComponent, View_CellContainerComponent_Host_0, {}, {}, ["*"]);
export { CellContainerComponentNgFactory as CellContainerComponentNgFactory };
